import { Box, Checkbox, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";
import SelectDropdown from "../../../Components/Common/FieldTypes/SelectDropdown/SelectDropdown";
import DatePicker from "../../../Components/FieldType/DatePicker/DatePicker";

function PreviewPage() {
  const navigate = useNavigate();

  const [formFields, setFormFields] = useState<{
    nationality: { value: string; warning: boolean };
    fullName: { value: string; warning: boolean };
    gender: { value: string; warning: boolean };
    ProposerDob: { value: Date | null; warning: boolean };
    motherName: { value: string; warning: boolean };
    mobile: { value: string; warning: boolean };
    email: { value: string; warning: boolean };
    passportNumnber: { value: string; warning: boolean };
    emergencyContactPerson: { value: string; warning: boolean };
    emergencyContact: { value: string; warning: boolean };
    occupation: { value: string; warning: boolean };
    employerName: { value: string; warning: boolean };
    employerAddress: { value: string; warning: boolean };
    taxRegNumber: { value: string; warning: boolean };
    description: { value: string; warning: boolean };
    streetArea: { value: string; warning: boolean };
    pincode: { value: string; warning: boolean };
    travellerfullName: { value: string; warning: boolean };
    travellergender: { value: string; warning: boolean };
    travellerDob: { value: Date | null; warning: boolean };
    travellermobile: { value: string; warning: boolean };
    travelleremail: { value: string; warning: boolean };
    travellerpassportNumnber: { value: string; warning: boolean };
    relationshipProposer: { value: string; warning: boolean };
    nomineefullName: { value: string; warning: boolean };
    nomineegender: { value: string; warning: boolean };
    nomineeDob: { value: Date | null; warning: boolean };
    nomineerelationshipProposer: { value: string; warning: boolean };
    nomineemobile: { value: string; warning: boolean };
    trusteeName: { value: string; warning: boolean };
    doctorname: { value: string; warning: boolean };
    doctormobile: { value: string; warning: boolean };
    doctoraddress: { value: string; warning: boolean };
  }>({
    nationality: { value: "", warning: false },
    fullName: { value: "", warning: false },
    gender: { value: "", warning: false },
    ProposerDob: { value: null, warning: false },
    motherName: { value: "", warning: false },
    mobile: { value: "", warning: false },
    email: { value: "", warning: false },
    passportNumnber: { value: "", warning: false },
    emergencyContactPerson: { value: "", warning: false },
    emergencyContact: { value: "", warning: false },
    occupation: { value: "", warning: false },
    employerName: { value: "", warning: false },
    employerAddress: { value: "", warning: false },
    taxRegNumber: { value: "", warning: false },
    description: { value: "", warning: false },
    streetArea: { value: "", warning: false },
    pincode: { value: "", warning: false },
    travellerfullName: { value: "", warning: false },
    travellergender: { value: "", warning: false },
    travellerDob: { value: null, warning: false },
    travellermobile: { value: "", warning: false },
    travelleremail: { value: "", warning: false },
    travellerpassportNumnber: { value: "", warning: false },
    relationshipProposer: { value: "", warning: false },
    nomineefullName: { value: "", warning: false },
    nomineegender: { value: "", warning: false },
    nomineeDob: { value: null, warning: false },
    nomineemobile: { value: "", warning: false },
    nomineerelationshipProposer: { value: "", warning: false },
    trusteeName: { value: "", warning: false },
    doctormobile: { value: "", warning: false },
    doctorname: { value: "", warning: false },
    doctoraddress: { value: "", warning: false },
  });
  const nationality_data = [
    { key: "India", value: "India" },
    { key: "USA", value: "USA" },
    { key: "Australia", value: "Australia" },
    { key: "UAE", value: "UAE" },
  ];

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const travelgender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const nomineegender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const relationshipProposer_data = [
    { key: "Mother", value: "Mother" },
    { key: "Father", value: "Father" },
    { key: "Brother", value: "Brother" },
  ];
  const nomineerelationshipProposer_data = [
    { key: "Mother", value: "Mother" },
    { key: "Father", value: "Father" },
    { key: "Brother", value: "Brother" },
  ];
  const occupation_data = [
    { key: "Salaried", value: "Salaried" },
    { key: "Self Employeed", value: "Self Employeed" },
    { key: "Private Employee", value: "Private Employee" },
    { key: "Retired", value: "Retired" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={10}>
                <GreyBoxTitle title="Proposer's Details" />
              </Grid>
              <Grid xs={2} alignSelf={"center"}>
                <div className="ctaBtn">
                  <CustomButton text_name="Modify" class_name="blueMdBtn" />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Does proposer is also an insured member ?"
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Nationality"
                  value={formFields.nationality.value}
                  attrName={["nationality", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={nationality_data}
                  warn_status={formFields.nationality.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.gender.value}
                  attrName={["gender", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={formFields.gender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.ProposerDob.value}
                  attrName={["ProposerDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.ProposerDob.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mother's Maiden Name"}
                  value={formFields.motherName.value}
                  attrName={["motherName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.motherName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Email"}
                  value={formFields.email.value}
                  attrName={["email", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.email.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Passport Number"}
                  value={formFields.passportNumnber.value}
                  attrName={[
                    "passportNumnber",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.passportNumnber.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Emergency Contact Person"}
                  value={formFields.emergencyContactPerson.value}
                  attrName={[
                    "emergencyContactPerson",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.emergencyContactPerson.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Emergency Contact"}
                  value={formFields.emergencyContact.value}
                  attrName={[
                    "emergencyContact",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.emergencyContact.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Occupation"
                  value={formFields.occupation.value}
                  attrName={["occupation", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={occupation_data}
                  warn_status={formFields.occupation.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Tax Registration No. (TRN)"}
                  value={formFields.taxRegNumber.value}
                  attrName={[
                    "taxRegNumber",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.taxRegNumber.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Business/Employer Name"}
                  value={formFields.employerName.value}
                  attrName={[
                    "employerName",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerName.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Employer's Address"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={12}>
                <h5
                  style={{
                    fontSize: "16px",
                    lineHeight: "26px",
                    fontWeight: "600",
                    marginBottom: "24px",
                  }}
                >
                  Do you or any member of your immediate family currently hold
                  or previously held a prominent public office{" "}
                </h5>
                <h6
                  style={{
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    marginBottom: "24px",
                  }}
                >
                  Description
                </h6>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "16px",
                    fontWeight: "500",
                    marginBottom: "12px",
                  }}
                >
                  Lorem ipsum is simply dummy text of the printing
                </p>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={10}>
                <GreyBoxTitle title="Permanent Address" />
              </Grid>
              <Grid xs={2} alignSelf={"center"}>
                <div className="ctaBtn">
                  <CustomButton text_name="Modify" class_name="blueMdBtn" />
                </div>
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Pincode"}
                  value={formFields.pincode.value}
                  attrName={["pincode", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.pincode.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Area"}
                  value={formFields.streetArea.value}
                  attrName={["streetArea", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.streetArea.warning}
                />
              </Grid>

              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Street"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={6}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Address Line 1"}
                  value={formFields.employerAddress.value}
                  attrName={[
                    "employerAddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.employerAddress.warning}
                />
              </Grid>
              <Grid xs={10}>
                <GreyBoxTitle title="Traveller Details" />
              </Grid>
              <Grid xs={2} alignSelf={"center"}>
                <div className="ctaBtn">
                  <CustomButton text_name="Modify" class_name="blueMdBtn" />
                </div>
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.travellerfullName.value}
                  attrName={[
                    "travellerfullName",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.travellerfullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.travellergender.value}
                  attrName={[
                    "travellergender",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  dropdown_data={travelgender_data}
                  warn_status={formFields.travellergender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.travellerDob.value}
                  attrName={[
                    "travellerDob",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.travellerDob.warning}
                />
              </Grid>
              <Grid xs={3}>
                <SelectDropdown
                  class_name="inputField"
                  title="Relationship with proposer"
                  value={formFields.relationshipProposer.value}
                  attrName={[
                    "relationshipProposer",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  dropdown_data={relationshipProposer_data}
                  warn_status={formFields.relationshipProposer.warning}
                />
              </Grid>
              <Grid xs={3}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Passport Number"}
                  value={formFields.travellerpassportNumnber.value}
                  attrName={[
                    "travellerpassportNumnber",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.travellerpassportNumnber.warning}
                />
              </Grid>
              <Grid xs={3}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.travellermobile.value}
                  attrName={[
                    "travellermobile",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.travellermobile.warning}
                />
              </Grid>
              <Grid xs={3}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Email"}
                  value={formFields.travelleremail.value}
                  attrName={[
                    "travelleremail",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.travelleremail.warning}
                />
              </Grid>
              <Grid xs={10}>
                <GreyBoxTitle title="Nominee Details" />
              </Grid>
              <Grid xs={2} alignSelf={"center"}>
                <div className="ctaBtn">
                  <CustomButton text_name="Modify" class_name="blueMdBtn" />
                </div>
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.nomineefullName.value}
                  attrName={[
                    "nomineefullName",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.nomineefullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.nomineegender.value}
                  attrName={[
                    "nomineegender",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  dropdown_data={nomineegender_data}
                  warn_status={formFields.nomineegender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.nomineeDob.value}
                  attrName={["nomineeDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.nomineeDob.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Relationship with proposer"
                  value={formFields.nomineerelationshipProposer.value}
                  attrName={[
                    "nomineerelationshipProposer",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  dropdown_data={nomineerelationshipProposer_data}
                  warn_status={formFields.nomineerelationshipProposer.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.nomineemobile.value}
                  attrName={[
                    "nomineemobile",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.nomineemobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"If under 18, Trustee Name"}
                  value={formFields.trusteeName.value}
                  attrName={["trusteeName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.trusteeName.warning}
                />
              </Grid>
              <Grid xs={10}>
                <GreyBoxTitle title="Medical Details" />
              </Grid>
              <Grid xs={2} alignSelf={"center"}>
                <div className="ctaBtn">
                  <CustomButton text_name="Modify" class_name="blueMdBtn" />
                </div>
              </Grid>
              <Grid xs={12}>
                <h5
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "700",
                    color: "#6458D8",
                    marginBottom: "24px",
                  }}
                >
                  Has anyone bee diagnosed / hospitalized / or under any
                  treatment for any illness / injury?
                </h5>
                <h6
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "700",
                    color: "#6458D8",
                    marginBottom: "0",
                  }}
                >
                  Henry
                </h6>
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Name of the  medical doctor or specialist"}
                  value={formFields.doctorname.value}
                  attrName={["doctorname", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.doctorname.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Doctor's Mobile Number"}
                  value={formFields.doctormobile.value}
                  attrName={[
                    "doctormobile",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.doctormobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Doctor’s Address"}
                  value={formFields.doctoraddress.value}
                  attrName={[
                    "doctoraddress",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.doctoraddress.warning}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Box
                  sx={{
                    background: "#F4F3FF",
                    padding: "20px",
                    borderRadius: "14px",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid xs={10}>
                      <GreyBoxTitle title="Travel Information" />
                    </Grid>
                    <Grid xs={2} alignSelf={"center"}>
                      <div className="ctaBtn">
                        <CustomButton
                          text_name="Modify"
                          class_name="blueMdBtn"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid
                xs={12}
                alignSelf={"center"}
                textAlign={"center"}
                marginTop={"20px"}
              >
                <div className="ctaBtn">
                  <CustomButton
                    text_name="Make Payment"
                    class_name="blueLgBtn"
                    onClickFunction={() => {
                      navigate(PATH.THANK_YOU);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PreviewPage;
